
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import { routerVcsMap } from '~/plugins/helpers/provider'

export default defineComponent({
  name: 'CoverageEnabledCard',
  props: {
    dsn: {
      type: String,
      required: true
    },
    vcsProvider: {
      type: String as PropType<routerVcsMap>,
      required: true,
      validator: (v: string) => Object.values(routerVcsMap).includes(v as routerVcsMap)
    },
    hasTestCoverage: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
})
